module.exports = __webpack_public_path__ + "img/produse.2a3ba59b.svg";